import type { TransferFailure } from 'features/feeBasedInstantTransfer/helpers/analyticsFormatters';
import { useEffect } from 'react';
import useEvent from 'shared/hooks/useEvent/useEvent';

/**
 * Calls `onFailure` when the shown status moves into a failure: from none to a
 * failure, or from one reason to another. Renders that keep the same failure
 * shown are not new occurrences; a retry passes through no failure, so failing
 * again is reported again.
 */
export default function useFailureTransition(
  failure: TransferFailure | undefined,
  onFailure: (failure: TransferFailure) => void,
) {
  const reportFailure = useEvent(() => {
    if (failure) {
      onFailure(failure);
    }
  });

  const failureReason = failure?.reason;
  useEffect(() => {
    reportFailure();
  }, [failureReason, reportFailure]);
}
